import {
  PRESS_KIT_PDF_DOWNLOAD_NAME,
  PRESS_KIT_PDF_DOWNLOAD_URL,
  PRESS_KIT_PDF_EMBED_URL,
} from "../pressAssets";
import { NOAN_PETRO_VERNEAU_URL } from "@/remerciementsAssets";

export function PressSection() {
  return (
    <section className="section press-section" id="presse">
      <div className="section-heading">
        <p className="kicker">Dossier de presse</p>
      </div>
      <div className="press-panel">
        <p>
          Le dossier de presse du spectacle réalisé par <a href={NOAN_PETRO_VERNEAU_URL}>Noan PETRO VERNEAU</a>
        </p>
        <div className="press-viewer">
          <iframe
            src={PRESS_KIT_PDF_EMBED_URL}
            title="Dossier de presse — Les Apprentis Dictateurs"
            loading="lazy"
          />
        </div>
        <a
          className="button primary"
          download={PRESS_KIT_PDF_DOWNLOAD_NAME}
          href={PRESS_KIT_PDF_DOWNLOAD_URL}
        >
          Télécharger le dossier de presse PDF
        </a>
      </div>
    </section>
  );
}
